import { useExternalOperatorApplyAmendmentController } from '../../../hooks/Amendments/useExternalOperatorApplyAmendmentController';
import useExternalOperatorDriversAutocomplete from '../../../hooks/Shippings/useExternalOperatorDriversAutocomplete';
import { childrenAmendmentsExternalOperatorsPageBreadcrumbs } from '../../../config/breadcrumbs';
import ExternalOperatorShippingDetails from '../../../components/ViewShipping/ExternalOperatorShippingDetails';
import Notification, { NotificationSeverity } from '@/components/notifications/Notification';
import {
  ShippingSearchInput,
  AmendmentForm,
  EmptyShippingSearch,
} from '@/pages/Business/pages/Amendments/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { History as HistoryIcon } from '@mui/icons-material';
import { NavigateLinks, GlobalButton } from '@/components';
import { useNavigate } from 'react-router-dom';
import { LoaderBackdrop } from '@/components';
import { useMemo } from 'react';

const ApplyAmendment = () => {
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenAmendmentsExternalOperatorsPageBreadcrumbs(navigate),
    [navigate]
  );

  const {
    shipping,
    isShippingLoading,
    searchKey,
    draftSearchInput,
    handleSearch,
    amendmentOptions,
    isAmendmentsLoading,
    handleApply,
    isApplying,
    successMessage,
    errorMessage,
    setSuccessMessage,
    setErrorMessage,
  } = useExternalOperatorApplyAmendmentController();

  return (
    <section className='flex flex-col w-full h-full gap-10'>
      <div className='flex flex-col gap-4'>
        <NavigateLinks actualPage='Enmiendas' breadcrumbs={breadcrumbs} />
        <div className='flex justify-end'>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => navigate('/business-external-operators/amendments/history')}
          >
            <HistoryIcon />
            Historial de enmiendas
          </GlobalButton>
        </div>
      </div>

      <div className='w-full flex flex-col gap-6'>
        <ShippingSearchInput
          key={searchKey}
          onSearch={handleSearch}
          isLoading={isShippingLoading}
          defaultValue={searchKey === 0 ? draftSearchInput ?? '' : ''}
        />

        {!shipping && <EmptyShippingSearch />}

        {shipping && (
          <>
            <div className='bg-white rounded-lg shadow-md p-6 border border-gray-200'>
              <ExternalOperatorShippingDetails shipping={shipping} />
            </div>

            <AmendmentForm
              key={String(shipping.id)}
              amendmentOptions={amendmentOptions}
              isAmendmentsLoading={isAmendmentsLoading}
              onApply={handleApply}
              isApplying={isApplying}
              currentStatusName={shipping.status ?? ''}
              useDriversAutocompleteHook={useExternalOperatorDriversAutocomplete}
            />
          </>
        )}
      </div>

      {isShippingLoading && <LoaderBackdrop />}

      <Notification
        open={!!successMessage}
        message={successMessage ?? ''}
        severity={NotificationSeverity.success}
        duration={5000}
        onClose={() => setSuccessMessage(null)}
      />
      <Notification
        open={!!errorMessage}
        message={errorMessage ?? ''}
        severity={NotificationSeverity.error}
        duration={5000}
        onClose={() => setErrorMessage(null)}
      />
    </section>
  );
};

export default ApplyAmendment;
